module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon2.7abcf650b323361db429a0a76c6de797.png";